export { default } from './FacetDrawerToggle';



// WEBPACK FOOTER //
// ./app/components/shared/Facets/FacetDrawerToggle/index.js